import React from 'react'
import { ChevronDown } from '../icons'
import './naglowek-filtrow.css'

export type OpcjaRegionu = { id: number; nazwa: string }

/** Region w nagłówku: zaokrąglony przycisk z listą. „Wszystkie” tylko tam, gdzie moduł je dopuszcza. */
export const PoleRegionu: React.FC<{
  regiony: OpcjaRegionu[]
  wartosc: number | null
  pozwalaWszystkie: boolean
  onZmiana: (id: number | null) => void
}> = ({ regiony, wartosc, pozwalaWszystkie, onZmiana }) => (
  <label className="nf-pole nf-pole-region">
    <span className="nf-podpis">Region</span>
    <select
      aria-label="Region"
      className="nf-select"
      value={wartosc == null ? '' : String(wartosc)}
      onChange={(e) => onZmiana(e.target.value ? Number(e.target.value) : null)}
    >
      {pozwalaWszystkie && <option value="">Wszystkie</option>}
      {!pozwalaWszystkie && wartosc == null && <option value="" disabled>Wybierz…</option>}
      {regiony.map((r) => (
        <option key={r.id} value={String(r.id)}>{r.nazwa}</option>
      ))}
    </select>
    <ChevronDown className="nf-strzalka" aria-hidden />
  </label>
)
